import { createAction } from 'redux-actions';

import {
  LOAD_PREFERRED_SITE_LIST,
  LOAD_PREFERRED_SITE_LIST_SUCCESS,
  LOAD_PREFERRED_SITE_LIST_ERROR,
  RESET_PREFERRED_SITE_LIST,
} from './type';

export const loadPreferredSiteListAction = createAction(
  LOAD_PREFERRED_SITE_LIST,
);
export const loadPreferredSiteListSuccessAction = createAction(
  LOAD_PREFERRED_SITE_LIST_SUCCESS,
);
export const loadPreferredSiteListErrorAction = createAction(
  LOAD_PREFERRED_SITE_LIST_ERROR,
);
export const resetPreferredSiteList = createAction(RESET_PREFERRED_SITE_LIST);
